@if (isListTable$ | async) {
    <sirius-table-list [rows]="rows" [title]="title"></sirius-table-list>
} @else {
    <sirius-table-regular [rows]="rows" [title]="title" [columnsNumber]="columns"></sirius-table-regular>
}
